import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import shortid from "shortid";
import { editingBook } from "../Redux/features/Edit/actions";
import addingBook from "../Redux/Thunk/addingBook";
import editBook from "../Redux/Thunk/editBook";
const AddNewsBook = () => {
 const editData = useSelector((state) => state.edit);
 const dispatch = useDispatch();
 const [name, setName] = useState("");
 const [author, setAuthor] = useState("");
 const [thumbnail, setThumbnail] = useState("");
 const [price, setPrice] = useState(0);
 const [rating, setRating] = useState(0);
 const [featured, setFeatured] = useState(false);
 const status = useRef();

 const handleSubmit = (e) => {
  e.preventDefault();
  const bookObj = {
   id: editData.id,
   name,
   author,
   thumbnail,
   price,
   rating,
   featured,
  };

  if (status.current.innerText === "update book") {
   setTimeout(() => {
    dispatch(editBook(bookObj));
   }, 500);
  } else {
   bookObj.id = shortid.generate();
   dispatch(addingBook(bookObj));
  }
  dispatch(editingBook({}));
  e.target.name.value = "";
  e.target.author.value = "";
  e.target.thumbnail.value = "";
  e.target.price.value = "";
  e.target.rating.value = "";
  e.target.featured.checked = "" || false;
 };
 useEffect(() => {
  const { name, author, price, thumbnail, rating, featured } = editData;
  setName(name);
  setAuthor(author);
  setPrice(price);
  setThumbnail(thumbnail);
  setRating(rating);
  setFeatured(featured);
 }, [editData]);
 return (
  <div>
   <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
    <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
    <form className="book-form" onSubmit={handleSubmit}>
     <div className="space-y-2">
      <label htmlFor="name">Book Name</label>
      <input
       required
       className="text-input"
       type="text"
       id="input-Bookname"
       name="name"
       value={name || ""}
       onChange={(e) => setName(e.target.value)}
      />
     </div>

     <div className="space-y-2">
      <label htmlFor="category">Author</label>
      <input
       required
       className="text-input"
       type="text"
       id="input-Bookauthor"
       name="author"
       value={author || ""}
       onChange={(e) => setAuthor(e.target.value)}
      />
     </div>

     <div className="space-y-2">
      <label htmlFor="image">Image Url</label>
      <input
       required
       className="text-input"
       type="text"
       id="input-Bookthumbnail"
       name="thumbnail"
       value={thumbnail || ""}
       onChange={(e) => setThumbnail(e.target.value)}
      />
     </div>

     <div className="grid grid-cols-2 gap-8 pb-4">
      <div className="space-y-2">
       <label htmlFor="price">Price</label>
       <input
        required
        className="text-input"
        type="number"
        id="input-Bookprice"
        name="price"
        value={price || ""}
        onChange={(e) => setPrice(e.target.value)}
       />
      </div>

      <div className="space-y-2">
       <label htmlFor="quantity">Rating</label>
       <input
        required
        className="text-input"
        type="number"
        id="input-Bookrating"
        name="rating"
        min="1"
        max="5"
        value={rating || ""}
        onChange={(e) => setRating(e.target.value)}
       />
      </div>
     </div>

     <div className="flex items-center">
      <input
       id="input-Bookfeatured"
       type="checkbox"
       name="featured"
       className="w-4 h-4"
       checked={featured || false}
       onChange={(e) => setFeatured(e.target.checked)}
      />
      <label htmlFor="featured" className="ml-2 text-sm">
       {" "}
       This is a featured book{" "}
      </label>
     </div>
     {editData.id && <input name="id" value={editBook.id} hidden />}
     <button ref={status} type="submit" className="submit" id="submit">
      {editData.id ? "update book" : "Add Book"}
     </button>
    </form>
   </div>
  </div>
 );
};

export default AddNewsBook;
